<script lang="ts">
	import { page } from '$app/stores';
	import { switchLanguageUrl, type Language, languageNames } from '$lib/i18n';
	import { captureEvent } from '$lib/analytics/posthog';

	interface Props {
		lang: Language;
	}

	let { lang }: Props = $props();

	let otherLang = $derived(lang === 'en' ? 'no' : 'en');
	let switchUrl = $derived(switchLanguageUrl($page.url.pathname, otherLang as Language));

	function handleClick() {
		captureEvent('language_switched', { from: lang, to: otherLang });
	}
</script>

<a
	href={switchUrl}
	onclick={handleClick}
	class="flex items-center gap-1 px-3 py-1.5 text-sm font-medium text-slate-400 hover:text-white transition-colors rounded-lg hover:bg-white/[0.04]"
	aria-label="Switch to {languageNames[otherLang as Language]}"
>
	<span class="uppercase text-xs tracking-wider">{lang}</span>
	<svg
		aria-hidden="true"
		class="w-3 h-3 mx-1 text-slate-600"
		fill="none"
		stroke="currentColor"
		viewBox="0 0 24 24"
	>
		<path
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="2"
			d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
		/>
	</svg>
	<span class="uppercase text-xs tracking-wider">{otherLang}</span>
</a>
